import React from 'react';
import Banner from './LandingComponents/Banner/Banner';
import CrowdMeter from './LandingComponents/CrowdMeter/CrowdMeter';
import Gallery from '../Gallery/Gallery';
import HowItWorks from './LandingComponents/HowItWorks/HowItWorks';
import CreateYourAccount from './LandingComponents/CreateYourAccount/CreateYourAccount';
import SeeOurPark from './LandingComponents/SeeOurPark/SeeOurPark';
import WhatWeGot from './LandingComponents/WhatWeGot/WhatWeGot';
import UpcomingEventsAndThemes from './LandingComponents/UpcomingEventsAndThemes/UpcomingEventsAndThemes';
import WhoWeAre from './LandingComponents/WhoWeAre/WhoWeAre';
import MostAskedQuestions from './LandingComponents/MostAskedQuestions/MostAskedQuestions';
import './LandingPage.css';

function LandingPage() {
  // Coming Soon Mode: Crowd meter is temporarily hidden until location is established
  // TODO: Uncomment when business opens and location is ready
  // <CrowdMeter />
  
  return (
    <div className="landing-page">
      <Banner />
      {/* Crowd meter temporarily hidden for coming soon launch */}
      {/* <CrowdMeter /> */}
      <HowItWorks />
      <div className="spacer first-wave"></div>
      <SeeOurPark />
      <div className="spacer second-wave"></div>
      <WhatWeGot />
      <div className="spacer third-wave"></div>
      <UpcomingEventsAndThemes />
      <div className="spacer fourth-wave"></div>
      <WhoWeAre />
      <div className="spacer fifth-wave"></div>
      <CreateYourAccount />
      <div className="spacer footer-wave"></div>
      {/* <MostAskedQuestions /> */}
      {/* <Gallery /> */}
      {/*Partners section when partners are secured */}
      {/*<Partners /> */}
    </div>
  );
}

export default LandingPage;
